(ns frontend.ux-overhaul.page-components.navigation.menu
  (:require
   [clojure.string :as string]
   [common.entity :as entity]
   [common.localization :as loc]
   [common.schema.entity-type-names :as entity-type-names]
   [common.util :as cu]
   [frontend.actions.common :as common-actions]
   [frontend.actions.deal :as deal-actions]
   [frontend.state.current-session :as session]
   [frontend.tenant-customizations :as tenant-customizations]
   [frontend.ux-overhaul.page-components.navigation.events :as events]
   [frontend.ux-overhaul.page-components.navigation.menu-items :as menu-items]
   [frontend.ux-overhaul.page-components.navigation.subs :as subs]
   [frontend.view.components.clipboard :as clipboard]
   [re-frame.core :as rf]
   [reagent.core :as r]
   [ui.components.button.view :as button]
   [ui.components.radix-ui.dropdown-menu.view :as dropdown-menu]
   [ui.components.radix-ui.separator.view :as separator]
   [ui.util :as uu]))

(defn menu-link-item
  [{:keys [label on-click! custom-label navbar-item-key]}]
  [:li
   {:id       navbar-item-key
    :class    "cursor-pointer py-2"
    :on-click on-click!}
   [:span {:class "flex gap-4 font-medium text-base-light-text hover:text-base-regular-text-accent"}
    [:div (if custom-label custom-label label)]]])

(defn menu-link-section
  [{:keys [menu-items title]}]
  [:div
   {:class "px-4"}
   [:div {:class "mb-2 font-medium text-[18px]"} title]
   [:ul
    (->> menu-items
         (map (fn [item]
                (let [{:keys [navbar-item-key]} item]
                  (when (cu/blank-value? navbar-item-key)
                    (js/console.log "Missing navbar item key : " title " >> " item " <<< " menu-items))
                  ^{:key (str "navbar-item-" navbar-item-key)}
                  [menu-link-item item])))
         (doall))]])

(defn links-grid-view
  []
  (let [all-navbar-grouped-items (->> (menu-items/all-available-navbar-items)
                                      (group-by :category-key))
        available-crm-items (:crm all-navbar-grouped-items)
        available-portfolio-items (:portfolio-management all-navbar-grouped-items)
        available-insight-and-repository-items (:insight-and-repository all-navbar-grouped-items)
        available-reports-items (:reports all-navbar-grouped-items)
        available-settings-items (:menu-settings all-navbar-grouped-items)
        available-survey-items (:surveys all-navbar-grouped-items)]
    [:div {:class "w-full flex flex-wrap gap-y-6 gap-x-16"}
     (when-not (and (empty? available-crm-items)
                    (session/is-guest?))
       [menu-link-section
        {:menu-items available-crm-items
         :title      (loc/tr :crm)}])
     (when-not (empty? available-insight-and-repository-items)
       [menu-link-section
        {:menu-items available-insight-and-repository-items
         :title      (loc/tr :back-office)}])
     (when-not (empty? available-portfolio-items)
       [menu-link-section
        {:menu-items available-portfolio-items
         :title      (loc/tr :portfolio-management)}])
     (when-not (empty? available-reports-items)
       [menu-link-section
        {:menu-items available-reports-items
         :title      (loc/tr :reports)}])
     (when (seq available-survey-items)
       [menu-link-section
        {:menu-items available-survey-items
         :title      (loc/tr :surveys)}])
     (when-not (empty? available-settings-items)
       [menu-link-section
        {:menu-items available-settings-items
         :title      (loc/tr :menu-settings)}])]))


(defn pipelines-item
  [id name entity-type]
  (let [pipeline-data (case entity-type
                        :entity.type/oppo
                        {:pipeline-badge (loc/tr :menu-dealflow-uc)
                         :module         :module/dealflow
                         :pipeline       :oppo-pipeline
                         :route          :oppos-grid-with-pipeline}

                        :entity.type/fundraising-opportunity
                        {:pipeline-badge (loc/tr :menu-fundraising-uc)
                         :module         :module/fundraising
                         :pipeline       :fundraising-opportunity-pipeline
                         :route          :fundraising-opportunities-grid-with-pipeline}

                        :entity.type/sales-opportunity
                        {:pipeline-badge (if (tenant-customizations/capman?)
                                           (loc/tr :menu-cws-pipeline-uc)
                                           (loc/tr :menu-sales-pipeline-uc))
                         :module         :module/sales-pipelines
                         :pipeline       :sales-opportunity-pipeline
                         :route          :sales-opportunities-grid-with-pipeline}

                        :entity.type/exit-opportunity
                        {:pipeline-badge (loc/tr :menu-exit-pipeline-uc)
                         :module         :module/exit-process-management
                         :pipeline       :exit-opportunity-pipeline
                         :route          :exit-opportunities-grid-with-pipeline}

                        {})]
    [:li
     {:on-click (fn []
                  (session/set-module! (:module pipeline-data))
                  (swap! session/selected-pipelines assoc (:pipeline pipeline-data) id)
                  (rf/dispatch [::events/navigate-to {:path [(:route pipeline-data) :pipeline-id id]}]))}
     [:span {:class "h-20 py-2 px-4 flex flex-col justify-center gap-1 border border-solid border-base-light-border-paler rounded hover:border-base-light-border-accent cursor-pointer"}
      [:div {:class "text-base-light-text-paler text-xs font-medium"}
       (:pipeline-badge pipeline-data)]
      [:div
       {:class "*:block *:p-0 text-left *:truncate *:text-left"}
       [button/secondary-open
        {:class   "text-xl font-medium w-full"
         :tooltip name}
        name]]]]))

(defn pipelines-section
  [title pipeline-items]
  (let [pipeline-count (count pipeline-items)
        grouped-pipelines (group-by :pipeline/entity-type pipeline-items)
        hardcoded-order [(:entity.type/oppo grouped-pipelines)
                         (:entity.type/fundraising-opportunity grouped-pipelines)
                         (:entity.type/sales-opportunity grouped-pipelines)
                         (:entity.type/exit-opportunity grouped-pipelines)]
        sorted (->> hardcoded-order
                    (reduce #(concat %1 (sort-by :pipeline/name %2))))]
    (when-not (= 0 pipeline-count)
      [:div
       [:div {:class "mb-2 font-medium text-[18px] text-base-light-text"} title]
       [:ul

        {:class "grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-4"}
        (->> sorted
             (map (fn [item]
                    (let [id (:db/id item)
                          name (:pipeline/name item)
                          entity-type (:pipeline/entity-type item)]
                      ^{:key (str "pipeline-item-" id)}
                      [pipelines-item id name entity-type])))
             (doall))]])))

(defn entity-type-badge
  [entity-type]
  (case entity-type
    :entity.type/person (loc/tr :favorites-badge-person)
    :entity.type/other-asset (loc/tr :favorites-badge-other-asset)
    :entity.type/sales-opportunity (loc/tr :favorites-badge-sales-oppo)
    :entity.type/fund-commitment (loc/tr :favorites-badge-fund-commitment)
    :entity.type/fund (loc/tr :favorites-badge-fund)
    :entity.type/kyc-profile (loc/tr :favorites-badge-kyc-profile)
    :entity.type/fof-asset (loc/tr :favorites-badge-fof-asset)
    (->> (entity-type-names/get-name entity-type :en)
         str
         string/upper-case)))

(defn favorites-item
  [item entity-type id]
  (let [favorites-badge (entity-type-badge entity-type)]
    [:li
     {:on-click (fn []
                  (rf/dispatch [::events/navigate-to {:path [entity-type :id id]}]))}
     [:span
      {:class "h-20 py-2 px-4 flex flex-col justify-center gap-1 border border-solid border-base-light-border-paler rounded hover:border-base-light-border-accent cursor-pointer"}
      [:div {:class "flex gap-2"}
       [:div {:class "flex gap-2 items-start group"}
        [:div {:class "m-0 text-base-light-text-paler font-md font-medium"}
         [:span
          [:i.fas.fa-star
           {:class "group-hover:hidden"}]
          [:i.fal.fa-star
           {:class    "hidden group-hover:inline"
            :on-click (fn [e]
                        (if (and (= entity-type :entity.type/oppo)
                                 (contains? (:oppo/flagged-by item)
                                            (:db/id @session/account)))                             ;TODO oppo has separate toggle (old)
                          (deal-actions/toggle-flag item true)
                          (common-actions/toggle-flag item true))
                        (.stopPropagation e))}]]]
        [:div
         {:class "*:justify-start *:p-0 *:block *:text-left"}
         [:div {:class "pt-1 text-base-light-text-paler text-xs font-medium"}
          favorites-badge]
         [button/secondary-open
          {:class   " w-[160px] text-xl font-medium truncate "
           :tooltip (entity/resolve-entity-name id session/get-entity session/reverse-lookup)}
          (entity/resolve-entity-name id session/get-entity session/reverse-lookup)]]]]]]))

(defn favorites-section
  [title favorite-entities]
  [:div
   (when-not (cu/blank-value? favorite-entities) [:div {:class "mb-2 font-medium text-[18px] text-base-light-text"} title])
   [:ul
    {:class "grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-4"}
    (->> favorite-entities
         (map (fn [item]
                (let [id (:db/id item)
                      entity-type (:entity/type item)]
                  ^{:key (str "favorite-item-" id)}
                  [favorites-item item entity-type id])))
         (doall))]])

(defn link-item
  [url title email? copy? visible?]
  [:div
   {:class (uu/cm "hidden space-between items-center font-medium text-md whitespace-nowrap"
                  (when visible? "flex"))}
   [:span
    {:class    (uu/cm "max-w-full flex items-center gap-2 text-base-light-text hover:text-base-regular-text-accent group cursor-pointer")
     :on-click (if email?
                 nil
                 (fn [e]
                   (.open js/window url "_blank")
                   (.preventDefault e)
                   (.stopPropagation e)))}
    [:span
     {:class "inline-block truncate"}
     title]
    (when copy?
      [button/secondary-open
       {:class   "invisible group-hover:visible group-hover:text-base-regular-text-accent"
        :tooltip (loc/tr :copy-to-clipboard)}
       [:i.fal.fa-copy
        {:on-click (fn [e]
                     (clipboard/copy-to url)
                     (.preventDefault e)
                     (.stopPropagation e))
         :class    "copy-icon"
         :style    {:cursor :pointer}}]])]])

(defn webforms-container
  [webentries]
  (let [container-ref-state (r/atom nil)
        max-webforms-state (r/atom (count webentries))
        set-max-webforms (fn [container-width container-dom-node]
                           (let [children (.-children container-dom-node)
                                 child-widths (->> children
                                                   (array-seq)
                                                   (map (fn [child-dom]
                                                          (let [rect (.getBoundingClientRect child-dom)]
                                                            (.-width rect)))))
                                 result (reduce (fn [{:keys [index available-width cumulative-width] :as result} next-width]
                                                  (if (> available-width next-width)
                                                    (assoc result
                                                      :index (inc index)
                                                      :cumulative-width (+ cumulative-width next-width)
                                                      :available-width (- available-width next-width))
                                                    result))
                                                {:index            -1
                                                 :cumulative-width (last child-widths)
                                                 :available-width  (- container-width
                                                                      (last child-widths)
                                                                      ;; padding for 'show more'
                                                                      40)}
                                                child-widths)]
                             (reset! max-webforms-state (:index result))))
        resize-listener (fn []
                          (when-let [container-ref @container-ref-state]
                            (let [rect (.getBoundingClientRect container-ref)
                                  width (.-width rect)]
                              (set-max-webforms width container-ref))))]
    (r/create-class
     {:component-did-mount    (fn []
                                (when-let [container-ref @container-ref-state]
                                  (let [rect (.getBoundingClientRect container-ref)
                                        width (.-width rect)]
                                    (set-max-webforms width container-ref)))
                                (.addEventListener js/window "resize" resize-listener))
      :component-will-unmount (fn []
                                (.removeEventListener js/window "resize" resize-listener))
      :reagent-render
      (fn [webentries]
        (let [active-entries (->> webentries
                                  (remove :common/archived?)
                                  (seq))
              origin (str (.-origin js/document.location) "/")
              webentry-address-start (str origin "webentry/")
              webforms-count (count webentries)
              visible-webforms-count (min @max-webforms-state (count webentries))]
          (when active-entries
            [:<>
             [:div {:class "p-0 md:p-2 w-full flex gap-2 flex-col md:flex-row items-start md:items-center flex overflow-x-hidden"}
              [:div {:class "m-0 text-sm text-base-light-text-paler whitespace-nowrap"}
               (if (= (count webentries) 1) "Web form link:" "Web form links:")]
              [:div
               {:ref   (fn [ref]
                         (when (and ref
                                    (not= @container-ref-state ref))
                           (reset! container-ref-state ref)))
                :class "flex items-center flex-1 gap-2 overflow-hidden"}
               (->> webentries
                    (remove :common/archived?)
                    (map-indexed (fn [idx item]
                                   (let [id (:db/id item)
                                         name (:webentry/display-name item)
                                         apikey (:webentry/apikey item)
                                         url (str webentry-address-start apikey)]

                                     ^{:key (str "webentry-item-" id)}
                                     [link-item url name false true (< idx visible-webforms-count)])))
                    (doall))
               [:div
                {:class (uu/cm "absolute right-2 hidden"
                               (when (> webforms-count visible-webforms-count) "block"))}
                [dropdown-menu/view
                 {:trigger [:div
                            {:on-click (fn [_e]
                                         (rf/dispatch [::events/toggle-webentries]))                ;TODO not working properly
                             :class    "p-2 text-base-light-text-accent hover:text-base-regular-text-contrast bg-complement-gloomy"}
                            (loc/tr :show-more)]
                  :items   (->> (drop visible-webforms-count webentries)
                                (map (fn [item]
                                       (let [name (:webentry/display-name item)
                                             apikey (:webentry/apikey item)
                                             url (str webentry-address-start apikey)]
                                         {:value        [link-item url name false true true]
                                          :custom-item? true})))
                                (doall))
                  :props   {:background-color "#38363B"
                            :margin           "0px 20px 20px 0px"
                            :hide-arrow?      true}}]]]]])))})))

(defn footer-separator
  []
  [:div {:class "flex justify-center items-center"}
   [:div {:class "h-5 text-base-light-text-paler"}
    [separator/view {:orientation :vertical}]]])

(defn footer
  [inbox-email webentries show-all-webentries?]
  [:div {:class "mt-auto px-4 py-3 flex gap-3 flex-start bg-complement-gloomy"}
   (when-not (session/is-guest?)
     [:div {:class "flex justify-center items-center"}
      [:span
       [link-item "https://help.zapflow.com/" "User guide" false false true]]])
   (when (session/dealflow?)
     [:<>
      [footer-separator]
      [:div {:class "flex justify-center items-center"}
       [:span {:class "m-0 px-2 flex items-center gap-4 text-md "}
        [:div {:class "m-0 text-base-light-text-paler text-sm whitespace-nowrap"} "Company inbox:"]
        [link-item inbox-email inbox-email true true true]]]])
   (when (session/dealflow?)
     [:<>
      [footer-separator]
      [webforms-container webentries show-all-webentries?]])])

(defn view
  []
  (let [on-key-down (fn [e] (when (= "Escape" (.-key e)) (rf/dispatch [::events/close-modal])))]
    (r/create-class
     {:component-did-mount    (fn []
                                (.addEventListener js/document.body "keydown" on-key-down))
      :component-will-unmount (fn []
                                (.removeEventListener js/document.body "keydown" on-key-down))
      :reagent-render
      (fn []
        (let [inbox-email @session/inbound-email-address
              oppo-pipelines (when (session/dealflow?)
                               (->> @session/oppo-pipelines
                                    (remove :pipeline/inactive?)))
              froppo-pipelines (when (session/fundraising?)
                                 (->> @session/froppo-pipelines
                                      (remove :pipeline/inactive?)))
              sales-pipelines (when (session/sales-pipelines?)
                                (->> @session/sales-oppo-pipelines
                                     (remove :pipeline/inactive?)))
              exit-pipelines (when (session/exit-process-management?)
                               (->> @session/exit-oppo-pipelines
                                    (remove :pipeline/inactive?)))
              pipelines (concat oppo-pipelines
                                froppo-pipelines
                                sales-pipelines
                                exit-pipelines)
              favorite-entities (sort-by :entity/type @session/flagged-entities)
              webentries (->> @session/all-webentries
                              (remove :common/disabled?)
                              (sort-by :common/created-on))
              show-all-webentries? @(rf/subscribe [::subs/show-all-webentries?])]
          [:div {:class "w-full h-[calc(100vh-53px)] right-0 left-0 mt-[53px] flex flex-col fixed z-[100] overflow-y-auto text-base-light-text bg-base-light"}
           [:div {:class "w-full m-0 flex flex-col flex-1"}
            [:div {:class "p-4 flex flex-1 flex-col gap-4"}
             [:div
              [pipelines-section "Pipelines" pipelines]]
             [:div
              [favorites-section "Favorites" favorite-entities]]]
            [:div {:class "w-full h-full flex flex-col justify-between bg-base-regular"}
             [:div {:class "my-6 mx-4 overflow-y-auto"}
              [links-grid-view]]]]
           [footer inbox-email webentries show-all-webentries?]]))})))
